export const HistoryTab = () => {
  return (
    <div className='p-4'>
      <p>Lịch sử phiếu nhập điều chuyển</p>
    </div>
  );
};
